import { Box, CSSObject, IconButton, Drawer as MuiDrawer, Stack, Theme, Typography, styled, useMediaQuery, useTheme } from '@mui/material';
import Hamburger from 'hamburger-react';
import { FC, PropsWithChildren, useCallback, useContext, useEffect } from 'react';
import { NavContext } from '../../../context/NavContext';

interface NavDrawerProps { }

const NavDrawer: FC<PropsWithChildren<NavDrawerProps>> = ({ children }) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'));
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptopL'));
  const navContextData = useContext(NavContext);
  const toggleNavExpanded = navContextData?.setNavExpanded;

  const toggleExpandNavigationDrawer = useCallback((isLaptop: boolean) => {
    if (toggleNavExpanded) toggleNavExpanded(!isLaptop)
  }, [toggleNavExpanded]);

  useEffect(() => {
    toggleExpandNavigationDrawer(isLaptop);
  }, [isLaptop, toggleExpandNavigationDrawer]);

  

  return (
    <Drawer
      variant="permanent"
      open={navContextData?.navExpanded}
      anchor={isTablet ? 'bottom' : 'left'}
      sx={{
        '.MuiPaper-root':
        {
          backgroundColor: '#3D4449',
          border: 0
        }
      }}
      PaperProps={{ elevation: 12 }}>
      <Stack sx={{
        color: 'white',
        [theme.breakpoints.up('tablet')]: {
          height: '100%'
        }
      }}
      >
        <Box id="ToggleNavExpand"
          sx={{
            marginTop: '12px',
            marginBottom: '12px',
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <IconButton
            onClick={() => navContextData?.setNavExpanded(!navContextData?.navExpanded)}
            sx={{
              [theme.breakpoints.down('tablet')]: {
                width: '50%'
              }
            }}>
            <Hamburger
              color="white"
              duration={0.5}
              toggled={navContextData?.navExpanded}
              distance="sm"
              size={24} />
            {isTablet &&
              <Typography sx={{ color: 'white' }}>Menu</Typography>
            }
          </IconButton>
        </Box>
        {children}
      </Stack>
    </Drawer>
  );
}

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop: any) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: "300px",
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      borderRight: "0px",
      backgroundImage: "linear-gradient(to right, #931216, #E20B23, #FF8230)",
      color: "white"
    },
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const openedMixin = (theme: Theme): CSSObject => ({
  [theme.breakpoints.up('tablet')]: {
    width: "300px",
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  },
  [theme.breakpoints.down('tablet')]: {
    transition: theme.transitions.create('height', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    height: '100vh',
    width: '100%',
    overflowY: 'hidden'
  },
});

const closedMixin = (theme: Theme): CSSObject => ({
  [theme.breakpoints.up('tablet')]: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(8)} + 1px)`
  },
  [theme.breakpoints.down('tablet')]: {
    transition: theme.transitions.create('height', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: '80px',
    width: '100%',
    overflowY: 'hidden'
  },
});

export default NavDrawer;
